class TaskQueue {
  private queue: (() => Promise<void>)[] = [];
  private running: boolean = false;

  async enqueueTask(task: () => Promise<void>): Promise<void> {
    // console.log("enqueue !!! length:", this.queue.length, this.running);
    this.queue.push(task);
    if (!this.running) {
      await this.processQueue();
    }
  }

  private async processQueue(): Promise<void> {
    this.running = true;
    while (this.queue.length > 0) {
      const task = this.queue.shift();
      // console.log("dequeue !!! length:", this.queue.length);
      if (task) {
        await task();
      }
      // console.log("end queue", this.queue.length);
    }

    this.running = false;
    // console.log("processQueue end queue", this.queue.length, this.running);
  }
}

const taskQueue = new TaskQueue();

export default taskQueue;
